<template>
  <div class="mx-pd-15" style="width:800px">
    <Collapse v-model="activeName" accordion class="collapse-slider mx-15">
      <CollapseItem v-for="(deliveryId,index) in deliveryIdList" :key="index" :name="index">
        <template slot="title">
          <span class="text-normal mr-5">{{ `${deliveryId && deliveryId.id}` }}</span>
          <span class="status-title" v-if="deliveryId && deliveryId.parent">
            <svgicon name="icon-status-m" width="10" height="8" />
          </span>
        </template>
        <AuditItem
          v-if="activeName === index"
          :order="order"
          :deliveryId="deliveryId"/>
      </CollapseItem>
    </Collapse>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { keyBy } from 'lodash';

import AuditItem from './AuditItem';

export default {
  props: ['order', 'deliveryIds', 'parentDelivery'],
  components: {
    AuditItem,
  },
  data() {
    return {
      currentDelivery: null,
      activeName: 0,
    };
  },
  computed: {
    ...mapGetters({
      deliverySummary: 'order/deliverySummary',
      currentUser: 'app/currentUser',
      cartonPageCount: 'order/subDeliveryPage',
      cartonDetails: 'order/subDeliveryDetails',
      hasEmpty: 'order/hasEmptySubDeliveryList',
    }),
    deliveryDetails() {
      return (this.deliverySummary &&
        this.deliverySummary.find(val => val.delivery_id.toString() === this.deliveryId.toString())) || {};
    },
    deliveryIdList() {
      if (this.deliveryIds) {
        const deliveryArray = this.deliveryIds.split(',');
        const deliveryDetails = [];
        // eslint-disable-next-line no-unused-expressions
        deliveryArray && deliveryArray.length && deliveryArray.forEach((_delivery) => {
          const obj = {};
          const deliver = _delivery.split('|');
          obj.id = deliver[0];
          obj.job = deliver[1];
          obj.parent = _delivery === this.parentDelivery;
          deliveryDetails.push(obj);
        });
        return deliveryDetails;
      }
      return (
        this.deliverySummary && this.deliverySummary.map((val) => {
          const obj = {};
          obj.id = val.delivery_id;
          obj.parent = val.is_parent_delivery;
          return obj;
        })
      );
    },
  },
  created() {},
  methods: {
    async loadCartonDetails($state = null) {
      try {
        const deliveryJobId = this.deliveryDetails && this.deliveryDetails.job_id;
        if (deliveryJobId) {
          const result = await this.$store.dispatch('order/getCartonDetails', {
            orderNo: this.orderNumber,
            jobId: deliveryJobId,
            page: this.cartonPageCount,
          });
          if (!result) {
            $state.complete();
            this.$errorMessage({ message: this.$t('GENERAL ERROR') });
          } else if (result && result.error) {
            $state.complete();
            this.$errorMessage({ message: result.error });
          }
          if ($state) {
            if (!this.hasEmpty) {
              $state.loaded();
            } else {
              $state.complete();
            }
          }
        } else {
          $state.complete();
        }
      } catch (err) {
        $state.complete();
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
  },
};
</script>
